import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
  createdAt: PropTypes.number,
  createdBy: PropTypes.string,
  updatedAt: PropTypes.number,
  updatedBy: PropTypes.string,
});
